export class ContentType {
  id: number;
  description: string;
}
